import { Box, IconNew as Icon, Text } from '@jfs/ui-new'
import { returnFunctionType } from './TimerFunctions'

export const timerSeparator = () => {
  return (
    <Box alignSelf="center">
      <Text type="body2">:</Text>
    </Box>
  )
}

export const renderTimer = (type: string) => {
  const isTimer = type === 'timer'
  return (
    <Box alignSelf="center">
      <Icon id={isTimer ? 'TIMER' : 'CALENDAR'} size={18} color="BLACK_21" />
    </Box>
  )
}

export const renderArrowKeys = (
  id: string,
  type: string,
  hour: number,
  setHours: (val: number) => void,
  minute: number,
  setMinutes: (val: number) => void,
  meridian: string,
  updateMeridian: (val: string) => void,
) => {
  const iconName = id === 'up' ? 'ARROW_UP' : 'ARROW_DOWN'

  return (
    <Box
      ph={8}
      borderRadius={6}
      underlayColor="GRAY_LIGHT"
      onPress={() => returnFunctionType(type, id, hour, setHours, minute, setMinutes, meridian, updateMeridian)}>
      <Icon id={iconName} size={16} color="BLACK_21" />
    </Box>
  )
}
